import { memo, useEffect, useRef } from 'react';
import { Coins, Shield, FlaskConical } from 'lucide-react';
import { useCreditsStore } from '../../store/creditsStore';

const ROLE_ICON = {
  admin: { Icon: Shield, className: 'credits-badge-admin-role' },
  tester: { Icon: FlaskConical, className: 'credits-badge-tester-role' },
};

const CreditsBadge = memo(({ onClick }) => {
  const balance = useCreditsStore(s => s.balance);
  const role = useCreditsStore(s => s.role);
  const fetchBalance = useCreditsStore(s => s.fetchBalance);
  const fetchCosts = useCreditsStore(s => s.fetchCosts);
  const prevBalance = useRef(balance);
  const animRef = useRef(null);

  useEffect(() => {
    fetchBalance();
    fetchCosts();
  }, [fetchBalance, fetchCosts]);

  useEffect(() => {
    const timer = setInterval(fetchBalance, 15000);
    return () => clearInterval(timer);
  }, [fetchBalance]);

  useEffect(() => {
    if (prevBalance.current !== null && balance !== null && balance !== prevBalance.current) {
      if (animRef.current) {
        animRef.current.classList.remove('credits-badge-pulse');
        void animRef.current.offsetWidth;
        animRef.current.classList.add('credits-badge-pulse');
      }
    }
    prevBalance.current = balance;
  }, [balance]);

  const roleIcon = ROLE_ICON[role];
  const RoleIcon = roleIcon?.Icon;

  const balanceClass =
    balance === null ? '' :
    balance <= 0 ? 'credits-badge-empty' :
    balance <= 5 ? 'credits-badge-low' : '';

  return (
    <button
      ref={animRef}
      className={`credits-badge ${balanceClass} ${roleIcon?.className || ''}`}
      onClick={onClick}
      title={`Créditos disponibles${role !== 'user' ? ` (rol: ${role})` : ''}`}
      data-testid="credits-badge"
    >
      {RoleIcon ? (
        <RoleIcon size={14} data-testid="credits-role-icon" />
      ) : (
        <Coins size={14} />
      )}
      <span className="credits-badge-value" data-testid="credits-balance-value">
        {balance !== null ? balance : '--'}
      </span>
    </button>
  );
});

CreditsBadge.displayName = 'CreditsBadge';
export default CreditsBadge;
